<template>
  <dd-header-card :data-dusk="'view-' + (view.id || view.view_id)" :collapsible="true" :header="view.name">
    <dd-form-grid v-if="hasInputs">

      <FillViewCatalogWithMemberHelper :view="value"></FillViewCatalogWithMemberHelper>

      <CoverageField
          v-if="hasInputs"
          v-for="(field, id) in orderedInputs"
          :key="field.attributes.name"
          :field="field"
          @update-field="(newField) => updateField(id, newField)"
          :view-uuid="value.uuid"
      ></CoverageField>
    </dd-form-grid>
    <div v-else>
      Geen velden voor deze dekking
    </div>
  </dd-header-card>
</template>

<script>
import CoverageField from "./CoverageField.vue";
import FillViewCatalogWithMemberHelper from "./FillViewCatalogWithMemberHelper.vue";

export default {
  name: "Coverage",
  components: {
    CoverageField,
    FillViewCatalogWithMemberHelper
  },
  props: {
    value: Object,
  },
  computed: {
    view() {
      return this.value;
    },
    hasInputs() {
      return Object.values(this.view).length;
    },
    orderedInputs() {
      return Object.values(this.view.inputs).sort((a, b) => a.order - b.order);
    }
  },
  emits: ["input"],
  methods: {
    updateField(catalog_id, newField) {
      let updatedViewClone = { ...this.view };
      updatedViewClone.inputs[catalog_id] = newField;
      this.$emit("update-view", updatedViewClone);
    }
  }
};
</script>

<style scoped>

</style>
